import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, RotateCcwIcon } from 'lucide-react';
type SlideNavProps = {
  tone?: 'paper' | 'accent';
  /** On the closing slide, Next becomes Replay. */
  isLast?: boolean;
};

/** Upper bound on deck length — the harness clamps at slide 0, so over-posting is safe. */
const REWIND_STEPS = 32;

/**
 * Next / Back controls. The deck harness owns navigation state and listens for
 * MP_NAVIGATE_SLIDE messages, so these buttons simply post that message rather
 * than holding any slide state of their own.
 */
export function SlideNav({
  tone = 'paper',
  isLast = false
}: SlideNavProps) {
  const accent = tone === 'accent';
  const go = (direction: 'prev' | 'next') => {
    window.postMessage({
      type: 'MP_NAVIGATE_SLIDE',
      direction
    }, '*');
  };
  const replay = () => {
    for (let step = 0; step < REWIND_STEPS; step += 1) go('prev');
  };
  const base = 'flex items-center gap-[0.5vw] rounded-full px-[1.5vw] py-[1.1vh] text-[clamp(10px,1.05vw,17px)] font-semibold transition-[background-color,color,transform,border-color] duration-150 ease-out active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2';
  return <div className="flex shrink-0 items-center gap-[0.8vw]" data-id="element-63" data-mp="2xjqn3c4umeeq">
      <button type="button" onClick={() => go('prev')} aria-label="Previous slide" className={[base, accent ? 'border border-white/40 text-white hover:bg-white/15 focus-visible:ring-white focus-visible:ring-offset-gapAccent' : 'border border-ink-line bg-paper-card text-ink hover:border-gapAccent hover:text-gapAccent focus-visible:ring-gapAccent focus-visible:ring-offset-paper'].join(' ')} data-id="element-64" data-mp="2xlbjz8emy9fr">
        <ArrowLeftIcon aria-hidden="true" className="h-[clamp(11px,1.15vw,18px)] w-[clamp(11px,1.15vw,18px)]" data-id="element-65" data-mp="3lfuzup5royuc" />
        Back
      </button>
      <button type="button" onClick={isLast ? replay : () => go('next')} aria-label={isLast ? 'Replay from the first slide' : 'Next slide'} className={[base, accent ? 'bg-white text-gapAccent hover:bg-white/90 focus-visible:ring-white focus-visible:ring-offset-gapAccent' : 'bg-gapAccent text-white hover:bg-[#6D28D9] focus-visible:ring-gapAccent focus-visible:ring-offset-paper'].join(' ')} data-id="element-66" data-mp="hsm8gyjedcah">
        {isLast ? <>
            <RotateCcwIcon aria-hidden="true" className="h-[clamp(11px,1.15vw,18px)] w-[clamp(11px,1.15vw,18px)]" data-id="element-67" data-mp="8r1q29jk3lv0" />
            Replay
          </> : <>
            Next
            <ArrowRightIcon aria-hidden="true" className="h-[clamp(11px,1.15vw,18px)] w-[clamp(11px,1.15vw,18px)]" data-id="element-68" data-mp="3v2p4ydh1c4ax" />
          </>}
      </button>
    </div>;
}